export default class facebookUser {
    name
    accessToken
    image
    email
    birthday
    genderId

    constructor( authResponse, userData ) {
        this.accessToken = authResponse.accessToken
        this.name = ( userData.name )? userData.name : null;
        this.image = ( userData.picture && userData.picture.data.url )? userData.picture.data.url : null;
        this.email = ( userData.email )? userData.email : null;
        this.birthday = ( userData.birthday )? userData.birthday : null;
        if( userData.gender ) {
            if( userData.gender == 'male' ) this.genderId = 1
            else this.genderId = 2
            
        } else this.genderId = null
    }
}